import React from "react";
import { ModalBody, Heading, Text } from "@chakra-ui/react";
export default function PrivacyPolict(props) {
  return (
    <ModalBody>
      <Text mt="2">
        At Hubit, accessible from hubitprototype.herokuapp.com/, one of our main
        priorities is the privacy of our visitors. This Privacy Policy document
        contains types of information that is collected and recorded by Hubit
        and how we use it.
      </Text>
      <Text mt="2">
        If you have additional questions or require more information about our
        Privacy Policy, do not hesitate to contact us.
      </Text>
      <Text mt="2">
        What personal information do we process? When you visit, use, or
        navigate our Services, we may process personal information depending on
        how you interact with Hubit and the Services, the choices you make, and
        the products and features you use. By default, we collect information on
        registration such as first name, last name, email address, phone number,
        and birth date.
      </Text>

      <Heading as="h2" fontSize="lg" mt="4">Log Files</Heading>
      <Text mt="2">
        Hubit follows a standard procedure of using log files. These files log
        visitors when they visit websites. All hosting companies do this and a
        part of hosting services' analytics. The information collected by log
        files include internet protocol (IP) addresses, browser type, Internet
        Service Provider (ISP), date and time stamp, referring/exit pages, and
        possibly the number of clicks. These are not linked to any information
        that is personally identifiable. The purpose of the information is for
        analyzing trends, administering the site, tracking users' movement on
        the website, and gathering demographic information. Our Privacy Policy
        was created with the help of the{" "}
        <a href="https://www.privacypolicygenerator.org">
          Privacy Policy Generator
        </a>
        .
      </Text>
      <Heading as="h2" fontSize="lg" mt="4">Privacy Policies</Heading>
      <Text mt="2">
        You may consult this list to find the Privacy Policy for each of the
        advertising partners of Hubit.
      </Text>
      <Text mt="2">
        Third-party ad servers or ad networks uses technologies like cookies,
        JavaScript, or Web Beacons that are used in their respective
        advertisements and links that appear on Hubit, which are sent directly
        to users' browser. They automatically receive your IP address when this
        occurs. These technologies are used to measure the effectiveness of
        their advertising campaigns and/or to personalize the advertising
        content that you see on websites that you visit.
      </Text>
      <Text mt="2">
        Note that Hubit has no access to or control over these cookies that are
        used by third-party advertisers.
      </Text>
      <Heading as="h2" fontSize="lg" mt="4">Third Party Privacy Policies</Heading>
      <Text mt="2">
        Hubit's Privacy Policy does not apply to other advertisers or websites.
        Thus, we are advising you to consult the respective Privacy Policies of
        these third-party ad servers for more detailed information. It may
        include their practices and instructions about how to opt-out of certain
        options.{" "}
      </Text>
      <Text mt="2">
        You can choose to disable cookies through your individual browser
        options. To know more detailed information about cookie management with
        specific web browsers, it can be found at the browsers' respective
        websites.
      </Text>
      <Heading as="h2" fontSize="lg" mt="4">Children's Information</Heading>
      <Text mt="2">
        Another part of our priority is adding protection for children while
        using the internet. We encourage parents and guardians to observe,
        participate in, and/or monitor and guide their online activity.
      </Text>
      <Text mt="2">
        Hubit does not knowingly collect any Personal Identifiable Information
        from children under the age of 18. If you think that your child provided
        this kind of information on our website, we strongly encourage you to
        contact us immediately and we will do our best efforts to promptly
        remove such information from our records.
      </Text>
      <Heading as="h2" fontSize="lg" mt="4">Online Privacy Policy Only</Heading>
      <Text mt="2">
        This Privacy Policy applies only to our online activities and is valid
        for visitors to our website with regards to the information that they
        shared and/or collect in Hubit. This policy is not applicable to any
        information collected offline or via channels other than this website.
      </Text>
      <Heading as="h2" fontSize="lg" mt="4">Consent</Heading>
      <Text mt="2">
        By using our website, you hereby consent to our Privacy Policy and agree
        to its Terms and Conditions.
      </Text>
    </ModalBody>
  );
}
